import React from 'react';
import { myTheme } from '../assets/styles/my-theme';
import { mergeStyleSets, TooltipHost } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { palette } = myTheme;

const classNames = mergeStyleSets({
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});


export interface TableIconVisibilitaProps {
}

const TableIconVisibilita: React.FunctionComponent<TableIconVisibilitaProps> = (props) => {
    return (
        <div className={classNames.iconField} >
            <TooltipHost content="Visibilità" id={"tooltipVisibilita"}>
                <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'eye' }} style={{ fontSize: 16, color: palette.themePrimary }} />
            </TooltipHost>
        </div>
    );
}
export default TableIconVisibilita;